import { render, staticRenderFns } from "./add-release.vue?vue&type=template&id=1bb6b0f8&scoped=true&"
import script from "./add-release.vue?vue&type=script&lang=js&"
export * from "./add-release.vue?vue&type=script&lang=js&"
import style0 from "./add-release.vue?vue&type=style&index=0&id=1bb6b0f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb6b0f8",
  null
  
)

export default component.exports